<button (click)="open = !open">
  <dgx-components-icon name="bolt"></dgx-components-icon>
  <h2>Electrical risks</h2>
  <dgx-components-icon
    [name]="open ? 'chevron-up' : 'chevron-down'"
    size="lg"
  ></dgx-components-icon>
</button>

<p>If your product isn’t working normally, please follow this safety advice.</p>

<section
  [style.height.px]="open ? innerContent.clientHeight : '0'"
  class="hidden-content"
  [class.open-box]="open"
  [attr.aria-hidden]="open ? null : true"
  [attr.inert]="open ? null : ''"
>
  <section #innerContent>
    <ul>
      <li>Turn it off and unplug it from the mains, if you can safely</li>
      <li>
        Or, in your fuse box, turn off the circuit breaker for the room where
        the appliance is
      </li>
    </ul>

    <p>
      For more advice, visit
      <a href="https://www.electricalsafetyfirst.org.uk/" target="_blank"
        >Electrical Safety First</a
      >.
    </p>
  </section>
</section>
